/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'kpi-blue': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M11 0v4a3 3 0 003 3h4v10a3 3 0 01-3 3H5a3 3 0 01-3-3V3a3 3 0 013-3h6zM6 12.523c-.556.012-1 .467-1 1.023V17a1 1 0 002 0v-3.5a.978.978 0 00-1-.977zM14 10a1 1 0 00-1 1v6a1 1 0 002 0v-6a1 1 0 00-1-1zm-4-2a1 1 0 00-1 1v8a1 1 0 002 0V9a1 1 0 00-1-1zm3-7.414L17.414 5H14a1 1 0 01-1-1V.586z" _fill="#213F6B"/>'
  }
})
